import { AttributeValue } from "./AttributeValue";
import { AttributeView } from "./AttributeView";
import { CarType, ODDataType } from "@/geoMap/layerFactory/IODLayerName";
import { ExportValue } from "./ExportValue";
import { Feature } from "ol";
import { FeatureType } from "@/geoMap/define/FeatureType";
import { IAttributeConvert } from "./IAttributeConvert";

/**
 * 画面幅
 */
const VALUE_WIDTH = 440;

/**
 * 画面高さ
 */
const VALUE_HEIGHT = 320;

/**
 * 出力JSONファイル名
 */
const VALUE_JSON_FILE_NAME = "od_triporg_yyyyMMdd_HHmmss.geojson";

/**
 * 出力CSVファイル名
 */
const VALUE_CSV_FILE_NAME = "od_triporg_yyyyMMdd_HHmmss.csv";

/**
 * OD量ノード情報属性変換用クラス
 */
export class ODNodeAttributeConvert implements IAttributeConvert {
  /**
   * 地物
   */
  feature: Feature;

  /**
   * データ種別
   */
  odDataType: ODDataType;

  /**
   * データ種別
   */
  carType: CarType;

  /**
   * 属性画面タイトル
   */
  title: string;

  constructor(feature: Feature, odDataType: ODDataType, carType: CarType) {
    this.feature = feature;
    this.odDataType = odDataType;
    this.carType = carType;
    this.title = `OD交通量（${odDataType}）（発）`;
  }

  /**
   * 地物タイプ取得
   */
  getFeatureType(): FeatureType {
    return FeatureType.ODNode;
  }

  /**
   * 画面用フォーマット取得
   */
  getViewFormatData(): AttributeView {
    const properties = this.feature.getProperties();

    // 調査年度
    const yearLabel = properties.年度 === "R03" ? "令和3年度" : properties.年度;

    // 画面項目定義リスト
    const items = [
      {
        key: "車種",
        value: this.carType,
        isSimple: true,
      },
      {
        key: "調査年度",
        value: yearLabel,
        isSimple: true,
      },
      {
        key: "ゾーン名",
        value: properties.ゾーン名称,
        isSimple: true,
      },
      {
        key: "選択ゾーン内々交通量",
        value: properties.内部トリップ数,
        isSimple: true,
      },
      {
        key: "選択ゾーン発交通量計",
        value: properties.上りトリップ数合計値,
        isSimple: true,
      },
      {
        key: "選択ゾーン着交通量計",
        value: properties.下りトリップ数合計値,
        isSimple: true,
      },
    ];
    // 画面項目リストでAttributeValue配列を生成しクラス変数に格納後、return
    const attributeValues: AttributeValue[] = [];
    items.forEach((item) => {
      if (
        item.key === items[3].key ||
        item.key === items[4].key ||
        item.key === items[5].key
      ) {
        attributeValues.push(
          new AttributeValue(
            item.key + "（トリップ）",
            item.value ? Number(item.value).toLocaleString() : null,
            item.isSimple
          )
        );
      } else {
        attributeValues.push(
          new AttributeValue(
            item.key,
            item.value ? item.value.toString() : null,
            item.isSimple
          )
        );
      }
    });
    const attributeView = new AttributeView(
      attributeValues,
      this.title,
      VALUE_WIDTH,
      VALUE_HEIGHT,
      VALUE_HEIGHT
    );
    return attributeView;
  }

  /**
   * ファイル出力用項目取得
   */
  getExportValue(): ExportValue {
    const feature = this.feature.clone();
    feature.getGeometry().transform("EPSG:3857", "EPSG:4326");
    const attributeValues = this.getViewFormatData().attributeValues;
    return new ExportValue(
      feature,
      attributeValues,
      VALUE_JSON_FILE_NAME,
      VALUE_CSV_FILE_NAME
    );
  }
}
